import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const RoleGuard = ({ roles = [1, 2, 3], children }) => {
  const { isAuthenticated, user } = useSelector(state => state.Login);

  if (!isAuthenticated) return <Navigate to="/signin" replace />;

  const role = Number(user?.role ?? 3);

  if (!roles.includes(role)) {
    const defaultPath = [3, 4].includes(role) ? "/home" : "/dashboard";
    return <Navigate to={defaultPath} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
